import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { generateWhatsappLink } from "../../../../../functions/generateWhatsappLink";
import { CustomerContext } from "../../../../../providers";
import { Button } from "../../../../tailwind/button";
import { Field, Fieldset, Legend } from "../../../../tailwind/fieldset";
import { Text } from "../../../../tailwind/text";
import { Textarea } from "../../../../tailwind/textarea";
import { SwitchOnOff } from "../../../../tailwind/switch";
import { Label } from "../../../../tailwind/fieldset";
import { api } from "../../../../../api";
import QrCodePreview from "./QrCodePreview";

const ManageTrigger = ({ nodes, setNodes, handleMessageChange, nodeData }) => {
  const { user } = useContext(CustomerContext);
  const [isQrCodeVisible, setIsQrCodeVisible] = useState(false);
  const [shouldPreventMultipleSendings, setShouldPreventMultipleSendings] =
    useState(true);
  const isCatalogue = nodeData.type === "order";

  useEffect(() => {
    if (user?.customer?.shouldPreventMultipleAutoReplySendings !== null) {
      setShouldPreventMultipleSendings(
        user.customer.shouldPreventMultipleAutoReplySendings,
      );
    }
  }, [user?.customer?.shouldPreventMultipleAutoReplySendings]);

  const whatsappLink = useMemo(() => {
    if (!user?.customer?.phoneNumber) {
      return "";
    }

    return generateWhatsappLink(
      user.customer.phoneNumber,
      nodeData.text,
      isCatalogue,
    );
  }, [user?.customer?.phoneNumber, nodeData.text]);

  const handleTextareaChange = useCallback(
    (event) => {
      handleMessageChange("text", event.target.value, nodes, setNodes);
    },
    [handleMessageChange, nodes, setNodes],
  );

  const handleShowQrCode = useCallback(() => {
    setIsQrCodeVisible(true);
  }, []);

  const handleTogglePreventMultipleSendings = useCallback(
    async (value) => {
      setShouldPreventMultipleSendings(value);
      try {
        await api.customer.update(user.customer.id, {
          shouldPreventMultipleAutoReplySendings: value,
        });
      } catch (error) {
        console.error("Error updating customer:", error);
      }
    },
    [user?.customer?.id],
  );

  return (
    <Fieldset>
      {!isCatalogue && (
        <Field>
          <Legend>Message that triggers the flow</Legend>
          <Textarea
            name="Message"
            placeholder="Any message"
            value={nodeData.text}
            onChange={handleTextareaChange}
            maxLength={1024}
            autoComplete="off"
            disabled={nodeData.disabled}
          />
        </Field>
      )}

      <Field>
        <div className="flex items-center justify-between mt-2">
          <Label>Do not trigger more than once in the last 8 hours</Label>
          <SwitchOnOff
            checked={shouldPreventMultipleSendings}
            onChange={handleTogglePreventMultipleSendings}
            color="dark/zinc"
          />
        </div>
      </Field>

      <Field>
        <Legend>WhatsApp redirection link</Legend>
        <Text className="max-w-[calc(28rem-2.5rem)] break-words">
          {whatsappLink}
        </Text>
      </Field>

      <Button
        className="mt-4"
        color="secondaryButton"
        onClick={handleShowQrCode}
      >
        Generate a QR Code
      </Button>

      {isQrCodeVisible && <QrCodePreview link={whatsappLink} />}
    </Fieldset>
  );
};

export default ManageTrigger;
